import { render } from "./AssignAuth.vue?vue&type=template&id=629cc81e&scoped=true"
import script from "./AssignAuth.vue?vue&type=script&lang=js"
export * from "./AssignAuth.vue?vue&type=script&lang=js"

import "./AssignAuth.vue?vue&type=style&index=0&id=629cc81e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629cc81e"]])

export default __exports__